import { Injectable, EventEmitter } from '@angular/core';
import { forkJoin, Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  SqlQueryBuilderService,
  PlatformDataService,
  UserInfoService,
  ShellDomainProvider,
  AggregateService,
  UtilityService,
  StorageDataService
} from '@ecap3/core';
import { TemplateAtlasSharedService } from './shared.services';
import { forEach, find, uniq, uniqBy } from 'lodash';
@Injectable({providedIn : 'root'})
export class PlatformChatService {
  private advisorInfo: any;
  private personEntityname = 'DeltaEmployee';
  private advisorDenormalizeEntityName = 'AdvisorDenormalized';
  private forCustomerPersonFiled = ['ItemId'];
  private userEntityname = 'User';
  private userTag = 'Person-For-User';
  private entityBasedChatEntityName = 'EntityBasedChat';
  private personField = ['ItemId'];
  public Pagination = {
    PageNumber: 0,
    PageSize: 100
  };
  LanguageKey = {
    'English': 'en-US',
    'French': 'fr-FR',
    'German': 'de-DE'
  };
  // DispatchTemplateName = 'slsn-mail-discuss';
  public Entity = {
    AdvisoryResource: 'AdvisoryResource',
    Category: 'Category',
    CountryInfo: 'CountryInfo',
    Connection: 'Connection',
    CoverageScope: 'CoverageScope',
    File: 'File',
    KeyBenefit: 'KeyBenefit',
    User: 'User',
    NetworkPartner: 'NetworkPartner',
    Partner: 'Partner',
    Person: 'Person',
    Resource: 'Resource',
    SLNProduct: 'SLNProduct',
    Tag: 'Tag',
    Contact: 'Contact',
    Employment: 'Employment',
    Education: 'Education',
    FinancialFlow: 'FinancialFlow',
    PlatformDictionary: 'PlatformDictionary',
    InvestInsure: 'InvestInsure',
    Liabilities: 'Liabilities',
    FixedAsset: 'FixedAsset',
    BankAccount: 'BankAccount',
    PersonIdentification: 'PersonIdentification',
    Investment: 'Investment',
    Insure: 'Insure',
    CustomerResource: 'CustomerResource',
    Retirement: 'Retirement',
    Loan: 'Loan',
    GeneralSupportTicket: 'GeneralSupportTicket',
    MailThread: 'MailThread',
    ServiceCheck: 'ServiceCheck',
    AdvisorDenormalized: 'AdvisorDenormalized',
    Goals: 'Goals',
    ProductSharedData: 'ProductSharedData',
    GdprContent: 'GdprContent',
    GdprUser: 'GdprUser',
    UserTermAndConditionGrant: 'UserTermAndConditionGrant',
    FinEcapBank: 'FinEcapBank',
    FinEcapUser: 'FinEcapUser',
    FinTransaction: 'FinTransaction',
    FinancialBudget: 'FinancialBudget'
  }
  private topicUrl: string;
  private additionalParam: any;
  // used for showing all notification in the chat box in real time
  private showingAllNotificationCommandArrived = new Subject<any[]>();
  showAllNotification = this.showingAllNotificationCommandArrived.asObservable();
  // showing all notification ends
  // notification showing box hide
  private hideNotificationBox = new Subject<boolean>();
  isHideNotificationBox = this.hideNotificationBox.asObservable();
  // notification showing box hide ends
  // after new message arrived updated notification
  private updateNotificationAfterMsgArrived = new Subject<boolean>();
  updateNotificationAfterMsg = this.updateNotificationAfterMsgArrived.asObservable();

  private currentThreadId: string;
  private recieverUserId: string;
  chats: any[];
  user: any;
  showingNotification: boolean;
  onChatSelected = new BehaviorSubject<any>(null);
  onPersonSelected = new BehaviorSubject<any>(null);
  onContactSelected = new BehaviorSubject<any>(null);
  onChatsUpdated = new Subject<any>();
  onUserUpdated = new Subject<any>();
  onLeftSidenavViewChanged = new Subject<any>();
  onRightSidenavViewChanged = new Subject<any>();
  onThreadArrived: EventEmitter<any[]> = new EventEmitter<any[]>();
  onTopicArrived: EventEmitter<any[]> = new EventEmitter<any[]>();
  onThreadSelected: EventEmitter<boolean> = new EventEmitter<boolean>();
  onSelectedPersonThread: EventEmitter<any> = new EventEmitter<any>();
  // when a brand new thread is created
  onNewThreadEmits: EventEmitter<boolean> = new EventEmitter<boolean>();
  onFloatingChatEmits: EventEmitter<any> = new EventEmitter<any>();
  // used to open floating chat but others tab except notification
  onFloatingChatSelectionCall: EventEmitter<any> = new EventEmitter<any>();
  // used to open floating chats notification tab
  onNotificationPanelClicked: EventEmitter<any> = new EventEmitter<any>();
  // used when new message arrived
  onNewMessageArrived: EventEmitter<any> = new EventEmitter<any>();
  onCurrentThreadSelcted: EventEmitter<string> = new EventEmitter<string>();
  onShowLoader: EventEmitter<boolean> = new EventEmitter<boolean>();
  private activeThreadId: string;
  private connectedPersonsEmail: string[];
  public ChatConfiguration: any; // Chat configuration coming from business application
  currentMailThreadId: string;
  currentUsersRole: string;
  hasThread: boolean;
  entiBasedChatSettings: any;
  header: any = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private sqlQueryBuilderService: SqlQueryBuilderService,
    private platformDataService: PlatformDataService,
    private userInfo: UserInfoService,
    private http: HttpClient,
    private sharedService: TemplateAtlasSharedService,
    private aggregateService: AggregateService,
    private storageService: StorageDataService,
    private utilityService: UtilityService) {
  }


  /**
   * Gettng all person for starting chat
   * param term,chatSettings,loggedinuserRole
   * return observable
   */
  getPerson(email, chatSettings, userRole): Observable<any[]> {
    const defaultqueriableFields = [
      'ItemId',
      'DisplayName',
      'Email'
    ];
    const modifiedEmail = email.replace(/[`~!#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
    const loggedInUserEmail = this.userInfo.userInfo.Email;
    const loggedInPersonId = this.userInfo.userInfo.PersonId;
    // if roles search condition is connection
    if (this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['SearchType'] === 'connection') {
      // ----------------------------------------------------------------------------
      // prepareGetConnectionQuery parameter value of sqlQueryBuilder
      // parentEntityName?:string, parentEntityValue?:any, childEntityName?:string, childEntityValue?:any, includeConnection?:boolean, tags?:any[], expandParent?:boolean, expandChild?:boolean
      // ----------------------------------------------------------------------------
      const getConnectQuery = this.sqlQueryBuilderService.prepareGetConnectionQuery(this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['ParentEntityName'], null, this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['ChildEntityName'], loggedInPersonId, false, this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['ConnectionTags'], false, false);
      return this.platformDataService.getConnections(getConnectQuery).pipe(switchMap((result: any) => {

        if (result && result.body && result.body.ErrorMessages && !result.body.ErrorMessages.length) {
          if (result.body.Results.length) {
            const personIdForDenormalizeTable = result.body.Results[0][this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['AfterConnectionResolveQueriableValue']];
            const sqlQuery = 'select<' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['AfterConnectionResolveQueriableFields'].join(',')
              + '> from<' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['AfterConnectionResolveQuerableEntityName']
              + '> where<Email =__reg(/' + modifiedEmail + '/i) __and '
              + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['AfterConnectionResolveQuerablePropertyName']
              + ' =__eql(' + personIdForDenormalizeTable + ')>';
            return this.platformDataService.getBySqlFilter('DeltaEmployee', sqlQuery, undefined);
          } else {
            return of(result);
          }
        } else {
          return of(result);
        }
      }));
    } else if (this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['SearchType'] === 'plain') {
      let sqlQuery = 'select<' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['QueriableFields'].join(',')
        + '> from<' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['EntityName']
        + '> where<Email =__reg(/' + modifiedEmail + '/i) __and Email = __ne(' + loggedInUserEmail + ')';
      if (this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole].AdditionalQueryFilterNeeded) {
        sqlQuery += this.getAdditionalFilters(this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole].AdditionalQueryFilters);
      }
      sqlQuery += '>';
      return this.platformDataService.getBySqlFilter(
        this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['EntityName'],
        sqlQuery,
        undefined
      );
    }
  }

  private getAdditionalFilters(filters): string {
    let query = '';
    filters.forEach(filter => {
      switch (filter.operator) {
        case '=':
          query += ' __and ' + filter.property + ' =__eql(' + filter.value + ')';
          break;
        case 'contains':
          query += ' __and ' + filter.property + ' =__in(' + filter.value + ')';
          break;
      }
    });
    return query;
  }

  /**
   * Title:setCurrentThreadId
   * Description: setting current thread id
   * param threadid
   * return void
   */
  public setCurrentThreadId(threadId): void {

    this.sharedService.currentSelectAssistantThreadId.next(threadId);
    this.currentThreadId = threadId;
  }

  /**
   * Title:setCurrentRecieverUserId
   * Description: setting current reciever personid
   * param email
   * return storing recievers User Id
   */
  public setCurrentRecieverUserId(email, currentUserRole?): void {
    let query = '';
    if (currentUserRole == 'customer') {

      query = this.sqlQueryBuilderService.prepareSqlFilterModel('Email', 'contains', email, this.advisorDenormalizeEntityName, this.forCustomerPersonFiled);
      this.platformDataService.getBySqlFilter(this.advisorDenormalizeEntityName, query, undefined).subscribe((response: any) => {

        if (response && response.body && response.body.Results.length) {
          this.recieverUserId = response.body.Results[0].ProposedUserId
        } else {
          this.recieverUserId = null;
        }
      });
    } else {
      query = this.sqlQueryBuilderService.prepareSqlFilterModel('Email', '=', email, this.personEntityname, this.personField, this.Pagination.PageNumber, this.Pagination.PageSize);

      this.platformDataService.getBySqlFilter(this.personEntityname, query, undefined).subscribe((response) => {

        if (response.body.Results.length > 0) {
          const getConnectQuery = this.sqlQueryBuilderService.prepareGetConnectionQuery(this.userEntityname, null, this.personEntityname, response.body.Results[0].ItemId, false, [this.userTag], false, false);
          getConnectQuery['PageNumber'] = 0;
          getConnectQuery['PageLimit'] = 1;

          this.platformDataService.getConnections(getConnectQuery).subscribe((res: Response) => {
            if (res.body['Results'] && res.body['Results'].length > 0) {
              this.recieverUserId = res.body['Results'][0].ParentEntityID;
            }
          });
        } else {
          this.recieverUserId = null;
        }
      });
    }
  }

  /**
   * Title:getCurrentRecieverUserId
   * Description: getting current recieverpersonid
   * param null
   * return recieverpersonsid
   */
  public getCurrentRecieverUserId(): string {
    return this.recieverUserId;
  }

  /**
   * Title:getCurrentThreadId
   * Description: getting current thread id
   * param null
   * return currentthreadid
   */
  public getCurrentThreadId(): string {
    return this.currentThreadId;
  }

  // public sendNotificationToReciever(payload): Observable<any> {
  //     return this.platformDataService.nofityUser(payload).map((response: any) => {
  //         return response;
  //     });
  // }

  /**
   * Title:resetChatContentHeight
   * Description: reseting chat contents height after messages loads
   * param null
   * return void
   */
  public resetChatContentHeight(): void {
    const chat_content = document.getElementById('chat-content');

    if (chat_content) {
      // if already in the bottom or in the middle of the chat container
      if (chat_content.scrollHeight - chat_content.scrollTop === chat_content.clientHeight) {
        chat_content.scrollTop = 0;
      } else {
        chat_content.scrollTop = chat_content.scrollHeight - chat_content.clientHeight;
      }
    }
  }

  /**
   * Title:resetChatContentHeight
   * Description: reseting chat contents height to top on chat users link click
   * param null
   * return void
   */
  public resetChatContentHeightOnUserClick(): void {
    const chat_content = document.getElementById('chat-content');

    if (chat_content) {
      chat_content.scrollTop = 0;
    }
  }

  /**
   * Title:resetChatContentHeightafterMessageSend
   * Description: reseting chat contents height after message sending button hit
   * param null
   * return void
   */
  public resetChatContentHeightafterMessageSend(): void {
    const chat_content = document.getElementById('chat-content');
    if (chat_content) {
      chat_content.scrollTop = chat_content.scrollHeight - chat_content.clientHeight;
    }
  }

  /**
   * Title: getFileInformation
   * Description: getting files full information
   * param  fle id
   * return observable<filesInfo>
   */
  public getFileInformation(fileId): Observable<any> {
    return this.storageService.getFilesInfo([fileId]).pipe(map((result: any) => {

      if (result && result.body && result.body.length) {
        return result.body;
      } else {
        //   console.log('no download url found for the file provided');
      }
    }));
  }

  /**
   * Title: getUserRole
   * Description: getting logged in users role
   * param null
   * return loggedin users role
   */
  public getUserRole() {
    const userdata = this.userInfo.userInfo;
    let role;
    if (userdata && userdata.Roles && userdata.Roles.length) {
      if (userdata.Roles.indexOf('admin') > -1) {
        role = 'admin';
      } else if (userdata.Roles.indexOf('admin_market') > -1) {
        role = 'admin_market';
      } else if (userdata.Roles.indexOf('advisor') > -1) {
        role = 'advisor';
      } else if (userdata.Roles.indexOf('customer') > -1) {
        role = 'customer';
      } else if (userdata.Roles.indexOf('branch_manager') > -1) {
        role = 'branch_manager';
      }
    }
    return role;
  }

  /**
   * Title: getAdvisorOfCustomer
   * Description: getting loggedInPersons advisor information
   * param logged in user personid
   * return Observable
   */
  public getAdvisorOfCustomer(loggedInPersonId): Observable<any> {
    const connectionFields = [
      'DisplayName',
      'Email',
      'PersonId'
    ];

    const getConnectQuery = this.sqlQueryBuilderService.prepareGetConnectionQuery('Person', null, 'Person', loggedInPersonId, false, ['Customer-Of-Advisor'], false, false);
    return this.platformDataService.getConnections(getConnectQuery).pipe(switchMap((result: any) => {

      if (result && result.body && result.body.ErrorMessages && !result.body.ErrorMessages.length) {
        if (result.body.Results.length) {
          const personIdForDenormalizeTable = result.body.Results[0].ParentEntityID;
          const sqlQuery = "select<" + connectionFields.join(',') + "> from<AdvisorDenormalized> where<PersonId = __eql(" + personIdForDenormalizeTable + ")>";

          return this.platformDataService.getBySqlFilter('DeltaEmployee', sqlQuery, undefined);
        } else {
          return of(result);
        }
      } else {
        return of(result);
      }
    }));
  }

  /**
   * Title:createThread
   * Description: Creating thread for newly created chat
   * param (threadInfo: any,Recipientlist:[],recieverPersonId:string)
   * return Observable
   */
  public createThread(threadInfo, recipientlist, recieverPersonId, selectedPersonInfo?): Observable<any> {
    threadInfo.MailThreadId = this.utilityService.getNewGuid();
    // ================================================
    // needed to register recipient with mailthread ===
    // ================================================
    const Mailreciever = {
      RecipientIds: recipientlist,
      ThreadId: threadInfo.MailThreadId
    };
    let insertModel: any;
    insertModel = this.generateInsertModel(threadInfo);
    // registering mail thread and recipients to get regular messages via chat window
    return this.http.post(ShellDomainProvider['api'].MessaginService + 'MailThreadingCommand/RegisterMailThread', threadInfo,
      { headers: this.header, withCredentials: true, observe: 'response' }).pipe(switchMap((response: any) => {
        // registering recipients with the mail thread to get regular messages via chat window
        if (response && response.body && response.body.ErrorMessages && !response.body.ErrorMessages.length) {
          return this.http.post(ShellDomainProvider['api'].MessaginService + 'MailThreadingCommand/RegisterRecipients', Mailreciever,
            { headers: this.header, withCredentials: true, observe: 'response' });
        } else {
          //  console.log(response.body.ErrorMessages);
        }
      })).pipe(switchMap((res: any) => {
        if (res && res.body && res.body.ErrorMessages && !res.body.ErrorMessages.length) {
          return this.platformDataService.insert(this.entityBasedChatEntityName, insertModel);
        } else {
          return res.body.ErrorMessages;
        }
      })).pipe(switchMap((insertResponse: any) => {
        if (insertResponse && insertResponse.body && insertResponse.body.ErrorMessages && !insertResponse.body.ErrorMessages.length) {
          selectedPersonInfo.ThreadId = threadInfo.MailThreadId;
          selectedPersonInfo.TopicName = threadInfo.TopicName;
          this.onSelectedPersonThread.next(selectedPersonInfo);
          return this.platformDataService.getRowLevelSecurity(this.entityBasedChatEntityName, insertModel.ItemId);
        }
      })).pipe(switchMap((getRowSecurityResponse: any) => {
        if (getRowSecurityResponse && getRowSecurityResponse.body && getRowSecurityResponse.body.ErrorMessages && !getRowSecurityResponse.body.ErrorMessages.length && getRowSecurityResponse.body.Results && getRowSecurityResponse.body.Results.length) {
          if (getRowSecurityResponse.body.Results[0].IdsAllowedToRead) {
            getRowSecurityResponse.body.Results[0].IdsAllowedToRead.push(recieverPersonId);
            getRowSecurityResponse.body.Results[0].EntityName = this.entityBasedChatEntityName;
            return this.platformDataService.changeSecurityPermissionWithRowLevelSecurity(getRowSecurityResponse.body.Results[0]);
          } else {
            //  console.log('No row level security for IdsAllowedToRead');
          }
        } else {
          //  console.log('Chat creation failure dew to having no row level security');
        }
      })).pipe(map((securityUpdateResponse: any) => {
        if (securityUpdateResponse && securityUpdateResponse.body && securityUpdateResponse.body.ErrorMessages && !securityUpdateResponse.body.ErrorMessages.length) {
          return securityUpdateResponse.body;
        }
      }));
  }

  /**
   * Title:getEntityBasedChatList
   * Description: getting entity based chats user list
   * param
   */
  getEntityBasedChatList(): Observable<any> {
    let threads = [];
    const userList = [];
    const query = 'Select<ItemId,TopicId,TopicEntityName,Recipients,TopicName,MailThreadId> from<' + this.entityBasedChatEntityName + '>where<Tags=__in(' + this.ChatConfiguration.tagsForEntityBasedChat + ')>';
    // const query = 'Select<ItemId,TopicId,TopicEntityName,Recipients,TopicName,MailThreadId> from<' + this.entityBasedChatEntityName + '>';
    const sqlFilterObj = {
      EntityName: this.entityBasedChatEntityName,
      Text: query,
      PageNumber: this.Pagination.PageNumber,
      PageSize: this.Pagination.PageSize
    };

    return this.aggregateService.getEntityAllDataByAggregate(this.entityBasedChatEntityName, sqlFilterObj).pipe(switchMap((response: any) => {

      if (response && response.length) {
        threads = response;
        const loggedInUserInfo = this.userInfo;
        let personIds = [];
        // const usersData = userList;
        forEach(response, function (personInfo, index) {
          const personId = find(personInfo.Recipients, function (o) {
            return o !== loggedInUserInfo.userInfo.PersonId;
          });
          userList.push({
            PersonId: personId,
            ThreadId: personInfo.MailThreadId,
            TopicName: personInfo.TopicName,
            TopicEntityName: personInfo.TopicEntityName,
            TopicId: personInfo.TopicId
          });
          personIds.push(personId);
        });
        personIds = uniq(personIds); // removing duplicate informations
        // =======================================================================
        // Creating query according to current loggedin users role
        // and given configuration according to role
        // =======================================================================
        let personQUery = '';
        let queryEntity = '';

        // setting query and entity name for query
        queryEntity = this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationQUeryEntity'];
        personQUery = 'Select<' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationFields'].join(',') + '> from<' + queryEntity + '>where <' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationConditionField'] + '=__in(' + personIds + ')>';
        const filterObjForPerson = {
          EntityName: queryEntity,
          Text: personQUery,
          PageNumber: this.Pagination.PageNumber,
          PageSize: this.Pagination.PageSize
        };
        // ======================================================================
        // checking current users role and create query according to that =======
        // ======================================================================
        return this.aggregateService.getEntityAllDataByAggregate(queryEntity, filterObjForPerson);
      } else {
        return of(response);
      }
    })).pipe(map((personsResponse: any) => {
      const loggedInUserInfo = this.currentUsersRole;
      const chatConfig = this.ChatConfiguration.SearchQueryRestrictionConfig;
      forEach(userList, function (userInfo, index) {
        forEach(personsResponse, function (personInfo, ind) {

          // ==================================================================
          // mapping according to given configuration and storing userInfo
          // ==================================================================
          if (personInfo[chatConfig[loggedInUserInfo]['PersonInformationConditionField']] === userInfo.PersonId) {
            userInfo['ProfileImage'] = personInfo.ProfileImage || null;
            userInfo['Name'] = personInfo.DisplayName;
            userInfo['Email'] = personInfo.Email;
          }

        });
      });

      this.onTopicArrived.emit(userList);
      return userList;
    }, (error: any) => {
      this.onTopicArrived.emit(error);
    }));
  }

  /**
   * Title:getEntityBasedChatList
   * Description: getting entity based chats user list
   * param
   */
  getAllChatPeople(): Observable<any> {
    let threads = [];
    let userList = [];
    const loggedInUserInfo = this.userInfo;
    let tagsForChat = (this.ChatConfiguration && this.ChatConfiguration.tagsForChat)?this.ChatConfiguration.tagsForChat:undefined;
    const query = 'Select<ItemId,TopicId,TopicEntityName,Recipients,TopicName,MailThreadId> from<' + this.entityBasedChatEntityName + '>where<Tags=__in(' + tagsForChat + ')>';
    const sqlFilterObj = {
      EntityName: this.entityBasedChatEntityName,
      Text: query,
      PageNumber: this.Pagination.PageNumber,
      PageSize: this.Pagination.PageSize
    };

    return this.aggregateService.getEntityAllDataByAggregate(this.entityBasedChatEntityName, sqlFilterObj).pipe(switchMap((response: any) => {

      if (response && response.length) {
        threads = response;
        let personIds = [];
        // const usersData = userList;
        forEach(response, function (personInfo, index) {
          const personId = find(personInfo.Recipients, function (o) {
            return o !== loggedInUserInfo.userInfo.PersonId;
          });
          userList.push({
            PersonId: personId,
            ThreadId: personInfo.MailThreadId,
            TopicName: personInfo.TopicName
          });
          personIds.push(personId);
        });
        personIds = uniq(personIds); // removing duplicate informations
        userList = uniqBy(userList, 'PersonId'); // removing duplicate information
        // =======================================================================
        // checking current users role and create query according to that ========
        // if user is a "customer" then query in advisor denormalized table ======
        // if user is a "advisor" then query in person table =====================
        // =======================================================================
        let personQUery = '';
        let queryEntity = '';
        let filterObjForPerson = null;
        // if persona is enabled for the user then query will be done in person entity
        if (this.userInfo['userInfo']['PersonaEnabled']) {
          // setting query and entity name for query
          queryEntity = 'Person';
          personQUery = 'Select<ItemId,ProfileImage,Email,DisplayName> from<' + queryEntity + '>where <ItemId=__in(' + personIds + ')>';
          filterObjForPerson = {
            EntityName: queryEntity,
            Text: personQUery,
            PageNumber: this.Pagination.PageNumber,
            PageSize: this.Pagination.PageSize
          };
        } else {
          // setting query and entity name for query
          queryEntity = this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationQUeryEntity'];
          personQUery = 'Select<' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationFields'].join(',') + '> from<' + queryEntity + '>where <' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationConditionField'] + '=__in(' + personIds + ')>';
          filterObjForPerson = {
            EntityName: queryEntity,
            Text: personQUery,
            PageNumber: this.Pagination.PageNumber,
            PageSize: this.Pagination.PageSize
          };
        }
        // ======================================================================
        // checking current users role and create query according to that =======
        // ======================================================================
        return this.aggregateService.getEntityAllDataByAggregate(queryEntity, filterObjForPerson);
      } else {
        return of(null);
      }
    })).pipe(map((personsResponse: any) => {
      if (personsResponse) {
        const loggedInUserRole = this.currentUsersRole;
        const userEmail = [];
        const loggedInuserInfo = this.userInfo;
        forEach(userList, function (userInfo, index) {
          forEach(personsResponse, function (personInfo, ind) {
            // ===========================================================================
            // if current users role is 'advisor' then check with persons ItemId =========
            // if current users role is 'customer' then check with personId ==============
            // ===========================================================================
            if (loggedInuserInfo['userInfo']['PersonaEnabled']) {
              if (personInfo.ItemId === userInfo.PersonId) {
                userInfo['ProfileImage'] = personInfo.ProfileImage;
                userInfo['Name'] = personInfo.DisplayName;
                userInfo['Email'] = personInfo.Email;
                userEmail.push(personInfo.Email);
              }
            } else {
              if (loggedInUserRole === 'advisor' || loggedInUserRole === 'manager') {
                if (personInfo.ItemId === userInfo.PersonId) {
                  userInfo['ProfileImage'] = personInfo.ProfileImage;
                  userInfo['Name'] = personInfo.DisplayName;
                  userInfo['Email'] = personInfo.Email;
                  userEmail.push(personInfo.Email);
                }
              } else if (loggedInUserRole === 'customer') {
                if (personInfo.PersonId === userInfo.PersonId) {
                  userInfo['Name'] = personInfo.DisplayName;
                  userInfo['Email'] = personInfo.Email;
                  userEmail.push(personInfo.Email);
                }
              }
            }
          });
        });
        this.connectedPersonsEmail = userEmail;
        this.onThreadArrived.emit(userList);
        return userList;
      } else {
        this.onThreadArrived.emit(null);
        return null;
      }
    }, (error: any) => {
      this.onThreadArrived.emit(error);
    }));
  }


  /**
  * Title:getEntityBasedChatListByPersonId
  * Description: getting entity based chats user list By PersonId
  * param
  */
  getAllChatPeopleByPersonId(personIds): Observable<any> {
     
    let threads = [];
    let userList = [];
    let tagsForChat = (this.ChatConfiguration && this.ChatConfiguration.tagsForChat)?this.ChatConfiguration.tagsForChat:undefined;
    const loggedInUserInfo = this.userInfo;
    const query = 'Select<ItemId,TopicId,TopicEntityName,Recipients,TopicName,MailThreadId> from<' + this.entityBasedChatEntityName + '>where<Tags=__in(' + tagsForChat + ')__and Recipients=__in(' + personIds + ')>';
    const sqlFilterObj = {
      EntityName: this.entityBasedChatEntityName,
      Text: query,
      PageNumber: this.Pagination.PageNumber,
      PageSize: this.Pagination.PageSize
    };

    return this.aggregateService.getEntityAllDataByAggregate(this.entityBasedChatEntityName, sqlFilterObj).pipe(switchMap((response: any) => {

      if (response && response.length) {
        threads = response;
        let personIds = [];
        // const usersData = userList;
        forEach(response, function (personInfo, index) {
          const personId = find(personInfo.Recipients, function (o) {
            return o !== loggedInUserInfo.userInfo.PersonId;
          });

          let tempObject = {
            PersonId: personId,
            ThreadId: personInfo.MailThreadId,
            TopicName: personInfo.TopicName
          };
          tempObject['Recipients'] = personInfo.Recipients;
          tempObject['TopicEntityName'] = personInfo.TopicEntityName;
          tempObject['TopicId'] = personInfo.TopicId;

          userList.push(tempObject);
          personIds.push(personId);
        });
        personIds = uniq(personIds); // removing duplicate informations
        userList = uniqBy(userList, 'PersonId'); // removing duplicate information
        // =======================================================================
        // checking current users role and create query according to that ========
        // if user is a "customer" then query in advisor denormalized table ======
        // if user is a "advisor" then query in person table =====================
        // =======================================================================
        let personQUery = '';
        let queryEntity = '';
        let filterObjForPerson = null;
        // if persona is enabled for the user then query will be done in person entity
        if (this.userInfo['userInfo']['PersonaEnabled']) {
          // setting query and entity name for query
          queryEntity = 'Person';
          personQUery = 'Select<ItemId,ProfileImage,Email,DisplayName> from<' + queryEntity + '>where <ItemId=__in(' + personIds + ')>';
          filterObjForPerson = {
            EntityName: queryEntity,
            Text: personQUery,
            PageNumber: this.Pagination.PageNumber,
            PageSize: this.Pagination.PageSize
          };
        } else {
          // setting query and entity name for query
          queryEntity = this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationQUeryEntity'];
          personQUery = 'Select<' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationFields'].join(',') + '> from<' + queryEntity + '>where <' + this.ChatConfiguration.SearchQueryRestrictionConfig[this.currentUsersRole]['PersonInformationConditionField'] + '=__in(' + personIds + ')>';
          filterObjForPerson = {
            EntityName: queryEntity,
            Text: personQUery,
            PageNumber: this.Pagination.PageNumber,
            PageSize: this.Pagination.PageSize
          };
        }
        // ======================================================================
        // checking current users role and create query according to that =======
        // ======================================================================
        return this.aggregateService.getEntityAllDataByAggregate(queryEntity, filterObjForPerson);
      } else {
        return of(null);
      }
    })).pipe(map((personsResponse: any) => {
      if (personsResponse) {
        const loggedInUserRole = this.currentUsersRole;
        const userEmail = [];
        const loggedInuserInfo = this.userInfo;
        forEach(userList, function (userInfo, index) {
          forEach(personsResponse, function (personInfo, ind) {
            // ===========================================================================
            // if current users role is 'advisor' then check with persons ItemId =========
            // if current users role is 'customer' then check with personId ==============
            // ===========================================================================
            if (loggedInuserInfo['userInfo']['PersonaEnabled']) {
              if (personInfo.ItemId === userInfo.PersonId) {
                userInfo['ProfileImage'] = personInfo.ProfileImage;
                userInfo['Name'] = personInfo.DisplayName;
                userInfo['Email'] = personInfo.Email;
                userEmail.push(personInfo.Email);
              }
            } else {
              if (loggedInUserRole === 'advisor' || loggedInUserRole === 'manager') {
                if (personInfo.ItemId === userInfo.PersonId) {
                  userInfo['ProfileImage'] = personInfo.ProfileImage;
                  userInfo['Name'] = personInfo.DisplayName;
                  userInfo['Email'] = personInfo.Email;
                  userEmail.push(personInfo.Email);
                }
              } else if (loggedInUserRole === 'customer') {
                if (personInfo.PersonId === userInfo.PersonId) {
                  userInfo['Name'] = personInfo.DisplayName;
                  userInfo['Email'] = personInfo.Email;
                  userEmail.push(personInfo.Email);
                }
              }
            }
          });
        });
        this.connectedPersonsEmail = userEmail;
        this.onThreadArrived.emit(userList);
        return userList;
      } else {
        this.onThreadArrived.emit(null);
        return null;
      }
    }, (error: any) => {
      this.onThreadArrived.emit(error);
    }));
  }


  /**
   * not using this function right now
   * Title:GetPersonsProfileImageByEmails
   * Description: Getting persons information
   * param email
   * return storing recievers User Id
   */
  public GetPersonsProfileImageByEmails(emails): Observable<any> {
    let query = '';


    if (this.currentUsersRole == 'customer') {
      query = this.sqlQueryBuilderService.prepareSqlFilterModel('Email', 'contains', emails, this.advisorDenormalizeEntityName, this.forCustomerPersonFiled, this.Pagination.PageNumber, this.Pagination.PageSize);
      return this.platformDataService.getBySqlFilter(this.advisorDenormalizeEntityName, query, undefined).pipe(map((response: any) => {

        if (response && response.body && response.body.Results.length) {
          return response.body.Results;
        } else {
          return null;
        }
      }));
    } else {
      query = this.sqlQueryBuilderService.prepareSqlFilterModel('Email', 'contains', emails, this.personEntityname, this.personField, this.Pagination.PageNumber, this.Pagination.PageSize);
      return this.platformDataService.getBySqlFilter(this.personEntityname, query, undefined).pipe(map((response: any) => {

        if (response && response.body && response.body.Results.length) {
          return response.body.Results;
        } else {
          return null;
        }
      }));
    }
  }

  /**
   * Getting entitybased chats result
   * @param topicId
   * @param entityName
   */
  public getEntityBasedChatInformation(topicId, entityName, fields): Observable<any> {
    let query = this.sqlQueryBuilderService.prepareSqlFilterModel('ItemId', '=', topicId, entityName, fields, this.Pagination.PageNumber, this.Pagination.PageSize);
    return this.platformDataService.getBySqlFilter(entityName, query, undefined).pipe(map((response: any) => {
      if (response && response.body && response.body.Results.length) {
        return response.body.Results;
      } else {
        return null;
      }
    }));
  }

  /**
   * Getting all message by threadId
   * param threadId
   * return observable
   */
  getMailsForThread(threadId: string, orderby?: any): Observable<any> {
    const chatList = [];
    let otherPersonEmail = [];
    this.currentMailThreadId = threadId;
    const loggedInUserId = this.userInfo.userInfo.PersonId; // Persons ItemId
    const loggedInUserEmail = this.userInfo.userInfo.Email; // Persons Email
    let topicEntityName = '';
    let topicId = '';
    let topicName = '';
    const payload = {
      ThreadId: threadId,
      OrderBy: orderby ? orderby : [
        {
          Property: 'SentOn',
          Order: 'Ascending'
        }
      ]
    };

    return this.http.post(ShellDomainProvider['api'].MessaginService + 'MailThreadingQuery/GetMailsForThread', payload,
      { headers: this.header, withCredentials: true, observe: 'response' }).pipe(switchMap((response: any) => {
        if (response.body && response.body.Results) {

          forEach(response.body.Results, function (value, index) {
            let messageInfo = {};
            if (!value.IsReply)
              messageInfo = JSON.parse(value.MailBody);
            else {
              messageInfo['message'] = value.MailBody;
              messageInfo['sender'] = value.ReceivedFrom;
            }
            chatList.push({
              message: messageInfo['message'],
              who: messageInfo['sender'],
              time: value.SentOn,
              attachment: value.Attachments
            });
            // if(messageInfo.sender !== loggedInUser){
            //   otherPersonIds.push(messageInfo.sender);
            // }
          });
          // otherPersonIds = uniq(otherPersonIds);
        } else {
          // reseting chat history and thread
          this.resetChatHistoryAndThread();
        }
        const query = 'Select<ItemId,TopicId,TopicEntityName,TopicName,Recipients> from<' + this.entityBasedChatEntityName + '>where <MailThreadId=__eql(' + threadId + ')>';
        return this.platformDataService.getBySqlFilter(this.entityBasedChatEntityName, query, undefined);
      })).pipe(switchMap((responseRecipient: any) => {
        let otherUserId = '';
        if (responseRecipient && responseRecipient.body && !responseRecipient.body.ErrorMessages.length && responseRecipient.body.Results && responseRecipient.body.Results.length) {
          otherUserId = find(responseRecipient.body.Results[0].Recipients, function (o) {
            return o != loggedInUserId;
          });
          topicEntityName = responseRecipient.body.Results[0].TopicEntityName ? responseRecipient.body.Results[0].TopicEntityName : null;
          topicId = responseRecipient.body.Results[0].TopicId ? responseRecipient.body.Results[0].TopicId : null;
          topicName = responseRecipient.body.Results[0].TopicName ? responseRecipient.body.Results[0].TopicName : null;

        }
        // this.onChatSelected.next({
        //   dialog: chatList,
        //   loggedInUserInfo: result.loggedInUserInfo.Results[0],
        //   whoUserInfo: result.whoUserInfo.Results[0]
        // });
        // this.onThreadSelected.next(true); // stop the loader

        const callList = [];
        const responseList = [];

        if (responseRecipient && responseRecipient.body && responseRecipient.body.length) {
          forEach(responseRecipient.body, function (value, index) {
            if (value.EmailAddress !== loggedInUserEmail) {
              otherPersonEmail.push(value.EmailAddress);
            }
          });
          otherPersonEmail = uniq(otherPersonEmail);
        }
        const personQueryField = ['Email', 'ProfileImage', 'ItemId', 'DisplayName'];
        const loggedInPersonsQuery = 'select<' + personQueryField.join(',') + '> from<Person> where<ItemId =__eql(' + this.userInfo.userInfo.PersonId + ')>';
        let WhoPersonsQuery = '';
        // if persona is enabled for the user then query will be done in person entity
        if (this.userInfo['userInfo']['PersonaEnabled']) {
          WhoPersonsQuery = 'select<' + personQueryField.join(',') + '> from<Person> where<ItemId =__eql(' + otherUserId + ')>';
        } else {
          // setting query and entity name for customer
          if (this.currentUsersRole === 'customer') {
            WhoPersonsQuery = 'Select<Email,DisplayName,PersonId> from<' + this.advisorDenormalizeEntityName + '>where <PersonId=__in(' + otherUserId + ')>';
          } else {
            WhoPersonsQuery = 'select<' + personQueryField.join(',') + '> from<Person> where<ItemId =__eql(' + otherUserId + ')>';
          }
        }
        const loggedInPersonsQuerymodel = {
          EntityName: this.Entity.Person,
          Text: loggedInPersonsQuery
        }
        const WhoPersonsQuerymodel = {
          EntityName: this.Entity.Person,
          Text: WhoPersonsQuery
        }
        const sqlFilterUrl = ShellDomainProvider['api'].DataCore + 'DataManipulationQuery/GetBySQLFilter';
        return forkJoin([
            this.http.post(sqlFilterUrl, loggedInPersonsQuerymodel, { headers: this.header, withCredentials: true, observe: 'response' }),
            this.http.post(sqlFilterUrl, WhoPersonsQuerymodel, { headers: this.header, withCredentials: true, observe: 'response' })
        ]).pipe(map(([loggedInRes, whoRes]: any[]) => ({
            loggedInUserInfo: loggedInRes.body,
            whoUserInfo: whoRes.body
        })));
      })).pipe(map((result: any) => {

        if (result && result.loggedInUserInfo && result.loggedInUserInfo.Results && result.whoUserInfo && result.whoUserInfo.Results) {
          const chatObj = {
            dialog: chatList,
            loggedInUserInfo: null,
            whoUserInfo: null,
            topicEntityName: null,
            topicId: null,
            topicName: null
          }

          if (result.loggedInUserInfo.Results.length) {
            if (ShellDomainProvider['api'].storageBucketBaseUrl && result.loggedInUserInfo.Results[0].ProfileImage) {
              result.loggedInUserInfo.Results[0].ProfileImage = ShellDomainProvider['api'].storageBucketBaseUrl.concat(result.loggedInUserInfo.Results[0].ProfileImage)
            }
            chatObj.loggedInUserInfo = result.loggedInUserInfo.Results[0];
          }

          if (result.whoUserInfo.Results.length) {
            if (ShellDomainProvider['api'].storageBucketBaseUrl && result.whoUserInfo.Results[0].ProfileImage) {
              result.whoUserInfo.Results[0].ProfileImage = ShellDomainProvider['api'].storageBucketBaseUrl.concat(result.whoUserInfo.Results[0].ProfileImage)
            }
            chatObj.whoUserInfo = result.whoUserInfo.Results[0];
          }
          chatObj.topicEntityName = topicEntityName;
          chatObj.topicId = topicId;
          chatObj.topicName = topicName;
          return chatObj;
        } else {
          return false;
        }
      }));
  }

  // ----------------------------------- on clicking submit button function executes ---------------------------------- //
  /**
   * Sending mail function handler
   * param message, senderid
   */
  sendMail(message, files?): Observable<any> {
    // let personInfo = this.userInfo.userInfo;
    // console.log(this.userInfo.userInfo);
    const senderDisplayName = this.userInfo.userInfo.FirstName + ' ' + this.userInfo.userInfo.LastName;
    const senderPersonId = this.userInfo.userInfo.PersonId;
    const emailTemplate = this.prepareEmailTemplate(message, senderDisplayName, senderPersonId);

    return this.sendMailToThread(emailTemplate, this.userInfo.userInfo.PersonId, files);
  }

  /**
   * Preparing email template for sending mail
   * param message, sender Displayname, senderId
   */
  prepareEmailTemplate(message, senderDisplayname, senderId): any {
    const emailTemplateKey = {};
    emailTemplateKey['message'] = message;
    emailTemplateKey['SenderDisplayName'] = senderDisplayname;
    emailTemplateKey['sender'] = senderId;
    return JSON.stringify(emailTemplateKey);
  }

  /**
   * Preparing mail to send to thread
   * param mailtemplate,senderid,attachement
   */
  sendMailToThread(mailTemplate, senderId, attachement?): Observable<any> {

    const mailHeader = {
      MailId: this.utilityService.getNewGuid(),
      ThreadId: this.currentMailThreadId,
      From: senderId,
      MailBody: mailTemplate,
      MailTemplateName: this.utilityService.getMailDiscussionTemplate(this.ChatConfiguration.DispatchTemplateName)
    };
    //return this.finallySendMailToThread(mailHeader, attachement);
    return this.sendMailPostForm(mailHeader, attachement);
  }

  /**
   * Send mail finall call to thread
   * param mailheader,attachment
   */
  finallySendMailToThread(mailHeader, attachment?): Observable<any> {

    const header: any = new HttpHeaders({
      'MailId': mailHeader.MailId,
      'ThreadId': mailHeader.ThreadId,
      'X-From': mailHeader.From,
      'MailBody': mailHeader.MailBody,
      'MailTemplateName': mailHeader.MailTemplateName
    });
    // this.header.append( 'MailId', mailHeader.MailId);
    // this.header.append( 'ThreadId', mailHeader.ThreadId);
    // this.header.append( 'X-From', mailHeader.From);
    // this.header.append( 'MailBody', mailHeader.MailBody);
    // this.header.append( 'MailTemplateName', mailHeader.MailTemplateName);

    return this.http.post(ShellDomainProvider['api'].MessaginService + 'SendMailToThread/Post', attachment,
      { headers: header, withCredentials: true, observe: 'response' }).pipe(map((result: any) => {

        if (result.body.ErrorMessages && !result.body.ErrorMessages.length) {
          return result;
        }
      }));

  }

  sendMailPostForm(mailHeader, attachments) {
    let payload = new FormData();
    if (attachments != null && attachments instanceof FormData) {
      payload = attachments;
    }
    Object.keys(mailHeader).forEach(function (item) {
      payload.append(item, mailHeader[item]);
    });

    let baseUrl = ShellDomainProvider['api'].MessaginService;

    return this.http.post(ShellDomainProvider['api'].MessaginService + 'SendMailToThread/PostFromForm', payload,
      { withCredentials: true, observe: 'body' }).pipe(map((result: any) => {
        result['body'] = result;
        if (result.body.ErrorMessages && !result.body.ErrorMessages.length) {
          return result;
        }
      }));
  }


  // ----------------------------------- on clicking submit button function executes ends ----------------------------------//

  /**
   * Reseting chat history,Thread and Loader
   * param void
   */
  resetChatHistoryAndThread() {
    this.onThreadArrived.emit([]); // clearing
    this.onChatSelected.next([]); // clear message list
    this.onThreadSelected.next(true); // true to stop the loader
  }

  /**
   * Title:generateInsertModel
   * Description: Generating insert model for entityBased Chat
   * param configInfo
   * return Object
   */
  generateInsertModel(configInfo: any) {
    const ItemId = this.utilityService.getNewGuid();
    return {
      ItemId: ItemId,
      Language: this.LanguageKey.English,
      TopicName: configInfo.TopicName,
      TopicEntityName: this.entityBasedChatEntityName,
      TopicId: ItemId,
      Recipients: configInfo.Recipients,
      Tags: this.ChatConfiguration.tagsForChat,
      MailThreadId: configInfo.MailThreadId
    };
  }

  // ------------------------- getting and setting active threadId starts ----------------------- //
  /**
   * Returning active threadId
   * return activeThreadId
   */
  getActiveThreadId(): any {
    return this.activeThreadId;
  }

  /**
   * Setting active threadId
   * params threadId
   */
  setActiveThreadId(threadId): any {
    this.activeThreadId = threadId;
    // emiting current threadId for further use
    this.onCurrentThreadSelcted.emit(threadId);
  }

  // ------------------------- getting and setting active threadId ends ----------------------- //
  // ----------- setting and getting notifcation showing status starts ----------------------- //
  // setting notification showing status
  setShowingNotificationStatus(status) {
    this.showingNotification = status;
  }

  // return show notification status
  getShowingNotificationStatus() {
    return this.showingNotification;
  }

  // ----------- setting and getting notifcation showing status ends ----------------------- //

  /**
   * Set user status
   * param status
   */
  setUserStatus(status) {
    this.user.status = status;
  }

  /**
   * Getting connected Persons Email
   * param obj
   */
  getConnectedPersonsEmail(): any[] {
    return this.connectedPersonsEmail;
  }

  /**
   * Adding recipient to thread
   * param recipient information
   * return Observable
   */
  addRecipientToThread(recipientInfo): Observable<any> {
    return this.http.post(ShellDomainProvider['api'].MessaginService + 'MailThreadingCommand/RegisterRecipients', recipientInfo,
      { headers: this.header, withCredentials: true, observe: 'response' });
  }

  /**
   * Title: showAllNotificationInChatBox
   * Description: show all notification in chat box
   * param notifications array
   * return void
   */
  public showAllNotificationInChatBox(notifications) {

    this.showingAllNotificationCommandArrived.next(notifications);
  }

  public hideNotificationChatBox(decision: boolean) {
    this.hideNotificationBox.next(decision);
  }

  updateNotification(decision: boolean) {
    this.updateNotificationAfterMsgArrived.next(decision);
  }

  setAdvisorInfo(info): void {
    this.advisorInfo = info;
  }

  getAdvisorInfo() {
    return this.advisorInfo;
  }

  /**
   * Title: setTopicUrl
   * Description: Setting topic related url
   * param url
   * return
   */
  setTopicUrl(url: string, additionalParam?) {
    this.topicUrl = url;
    this.additionalParam = additionalParam;
  }

  /**
   * Title: getTopicUrl
   * Description: getting topic urls
   * param null
   * return topics url
   */
  getTopicUrl() {
    return this.topicUrl;
  }

  /**
   * Title: getTopic additional Param
   * Description: getting topics additional param if there
   * param null
   * return {query params}
   */
  getTopicAdditionalParam() {
    return this.additionalParam;
  }

  /**
   * Title:setEntityBasedChatSettings
   * Description:setting entity based chats config
   * param configuration object
   * return
   */
  setEntityBasedChatSettings(config: any) {
    this.entiBasedChatSettings = config;
  }

  /**
   * Title:getEntityBasedChatSettings
   * Description:returning entity based chats config
   * param configuration object
   * return
   */
  getEntityBasedChatSettings() {
    return this.entiBasedChatSettings;
  }
}

